import type { VFC } from 'react';

import { useTranslation } from 'react-i18next';

import { Button } from '../../Button/Button';
import { login, logout } from '../../../services/schibstedAccount';

type Props = {
  isLoggedIn: boolean;
};

export const LoginButton: VFC<Props> = (props) => {
  const { isLoggedIn } = props;
  const { t } = useTranslation();

  return (
    <Button
      size="medium"
      variant="outlined"
      rounded
      onClick={() => (isLoggedIn ? logout() : login('user-menu'))}
    >
      {t(isLoggedIn ? 'Log out' : 'Log in')}
    </Button>
  );
};
